import { configureStore } from '@reduxjs/toolkit';
import { uiRootReducer } from './reducers';
import * as gameUIActions from './actions/gameUIActions';

export const uiStore = configureStore({
  reducer: uiRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    }),
  devTools: { actionCreators: gameUIActions, trace: true, traceLimit: 25 }
});

export type UIRootState = ReturnType<typeof uiStore.getState>;
export type UIAppDispatch = typeof uiStore.dispatch; 